"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DividerBottomSpace;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DividerBottomSpace(_ref) {
  var space = _ref.space,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: space
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    noMargin: true,
    appearance: appearance
  }));
}
DividerBottomSpace.propTypes = {
  space: _propTypes.default.number,
  appearance: _propTypes.default.string
};